<template functional>
    <footer class="the-footer flex-wrap justify-between mt-2" :class="classes">
        <p>
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a href="https://turbo-eg.com" target="_blank" rel="nofollow">{{ companyName }}</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <span class="md:flex hidden items-center">
          <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="mr-2" />
          <span>Hand-crafted & Made with</span>
        </span>
    </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  },
  data(){
    return {
      companyName: process.env.VUE_APP_CONFIGS_COMPANY_NAME
    }
  }
}
</script>
